/* eslint-disable react-hooks/exhaustive-deps */
import {
	Heading,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
} from "@chakra-ui/react";
import { ClubList } from "../Components/Clubs/ClubList";
import { Layout } from "../Components/Layout";
import { LoaderView } from "../Components/LoaderView";
import { useAuth } from "../contexts/authContext";
import theme from "../helpers/theme";

export const Main = () => {
	const { currentUser } = useAuth();

	if (!currentUser) return <LoaderView />;
	return (
		<Layout>
			<Heading mb="3rem">
				Welcome back, {currentUser && currentUser.displayName}
			</Heading>
			<Tabs
				variant="soft-rounded"
				colorScheme={theme.colours.accent}
				w="100%"
				d="flex"
				justifyContent="center"
				alignItems="center"
				flexDir="column"
			>
				<TabList
					userSelect="none"
					d="flex"
					flexDir={{ base: "column", md: "row" }}
					w={{ base: "100%", md: "auto" }}
					mb={8}
				>
					<Tab
						w={{ base: "100%", md: "auto" }}
						mr={{ base: "0", md: "1rem" }}
						mb={{ base: "1rem", md: "0" }}
					>
						School Clubs
					</Tab>
					{/* <Tab
						w={{ base: "100%", md: "auto" }}
						mr={{ base: "0", md: "1rem" }}
						mb={{ base: "1rem", md: "0" }}
					>
						Global Clubs
					</Tab> */}
					<Tab
						w={{ base: "100%", md: "auto" }}
						mr={{ base: "0", md: "1rem" }}
						mb={{ base: "1rem", md: "0" }}
					>
						My Clubs
					</Tab>
				</TabList>
				<TabPanels>
					<TabPanel>
						<ClubList clubs="school" />
					</TabPanel>
					{/* <TabPanel>
						<ClubList clubs="global" />
					</TabPanel> */}
					<TabPanel>
						<ClubList clubs="mine" />
					</TabPanel>
				</TabPanels>
			</Tabs>
		</Layout>
	);
};
